// extracted by mini-css-extract-plugin
export default {"hint":"QuestionHint__hint","fullWidth":"QuestionHint__fullWidth"};